<template>
    <v-container>
      <v-flex>
        <div>
          <v-layout>
            <v-flex>
              <v-text-field
                  v-model="$store.state.activitySearch"
                  label="Busqueda por palabra"
                  single-line
                  hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
        <v-layout>
            <v-flex>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
              >
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fechaInicio"
                        label="Fecha inicio"
                        readonly
                        v-on="on"
                        required
                        :rules="[v => !!v || 'Fecha inicio es requerida']"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaInicio" @input="menu = false"></v-date-picker>
                </v-menu>

                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fechaFin"
                        label="Fecha fin"
                        readonly
                        v-on="on"
                        required
                        :rules="[v => !!v || 'Fecha fin es requerida']"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaFin" @input="menu2 = false"></v-date-picker>
                </v-menu>
                <v-select
                    :items="estados"
                    v-model="estado"
                    label="Seleccione el estado"
                    required
                    :rules="[v => !!v || 'Estado es requerido']"
                ></v-select>

              </v-form>
              <div class="text-xs-center">
                <v-btn color="primary"
                       dark
                       @click="reloadData">Buscar
                </v-btn>
              </div>
            </v-flex>
        </v-layout>
        <h3 class="primary--text">Lista de Actividades</h3>
        <v-data-table
                :headers="headers"
                :items="this.activities"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="this.$store.state.activitySearch"
                hide-actions
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.id }}</td>
                <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                <td class="text-xs-left">{{ props.item.activityConfigurationCompany.company.name }}</td>
                <td class="text-xs-left">{{ props.item.activityConfigurationCompany.name }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td class="text-xs-left">{{ props.item.activityCompanyPeriod!=null?props.item.activityCompanyPeriod.name:"" }}</td>
                <td class="text-xs-left">
                  <v-chip
                      :color="getColor(props.item.status)"

                  >
                    <span>{{ props.item.status }}</span>
                  </v-chip>
                  </td>
                <td>
                  <a @click="getAnexos(props.item)">Anexos</a>

                </td>
                <td>
                  <a @click="editItem(props.item)" style="color: #006699">Ver Actividad</a>
                </td>
<!--                <td>-->
<!--                    <v-tooltip top>-->
<!--                        <v-btn fab dark small  @click="deleteItem(props.item)" slot="activator" color="primary">-->
<!--                            <v-icon dark>delete</v-icon>-->
<!--                        </v-btn>-->
<!--                        <span>Eliminar</span>-->
<!--                    </v-tooltip>-->
<!--                </td>-->
                <td>
                  <a v-if="(props.item.isMedico || props.item.isSupervisor) && (props.item.status=='CREADO' || (props.item.status=='RECHAZADO' && props.item.timesRejected<2))" @click="createApprove(props.item)" style="color: blue">{{props.item.status=='CREADO'?'Solicitar Aprobación':'Reenviar para Aprobación' }}</a>
                  <a v-if="props.item.isSupervisor && props.item.status=='PENDIENTE_APROBACION'" @click="dialogCommentApprove=true; activity=props.item" style="color: green">Aprobar</a>
                  <a v-if="props.item.isSupervisor && props.item.status=='PENDIENTE_APROBACION'" @click="dialogCommentReject=true; activity=props.item" style="color: red">Rechazar</a>
                </td>
                <td>
                  <a @click="dialogComments=true; selectItem(props.item)">Comentarios</a>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
        <v-dialog v-if="activity!=null"
                  v-model="dialog"
                  fullscreen
                  transition="dialog-bottom-transition"
                  scrollable>
            <v-card tile>
                <v-toolbar card dark color="nav_background_color">
                    <v-btn icon dark @click.native="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Actividad</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <h1>Datos actividad</h1>
                        <v-layout>
                            <v-flex xs12 sm4 offset-sm1>
                              <v-text-field
                                  label="Compania"
                                  readonly
                                  v-model="activity.activityConfigurationCompany.company.name"
                              ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm4 offset-sm1>
                              <v-text-field
                                  label="Actividad"
                                  readonly
                                  v-model="activity.activityConfigurationCompany.name"
                              ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm7 offset-sm1>
                                <v-text-field
                                        name="anfitrion"
                                        label="Nombre / Objetivo"
                                        id="anfitrion"
                                        readonly
                                        v-model="activity.name"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-text-field
                                        name="nota"
                                        label="Descripción"
                                        id="nota"
                                        v-model="activity.description"
                                        readonly
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <h1>Datos ejecución</h1>
                        <v-layout >
                            <v-flex xs12 sm10 offset-sm1>
                                <v-textarea v-for="item in activity.questions" :key="item.id"
                                        :label="item.question"
                                        v-model="item.response"
                                        :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 2000) || 'El número de caracteres debe ser menor a 2000']"
                                        :readonly="activity.isMedicoCliente || activity.status=='PENDIENTE_APROBACION' || activity.status=='APROBADO' || activity.timesRejected==2 || (activity.status=='RECHAZADO' && (activity.isMedicoCliente || activity.isSupervisor))"
                                        required
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm6 offset-sm4>
                                <div>
                                    <v-btn :disabled="!valid" v-if="!(activity.isMedicoCliente || activity.status=='PENDIENTE_APROBACION' || activity.status=='APROBADO' || activity.timesRejected==2 || (activity.status=='RECHAZADO' && (activity.isMedicoCliente || activity.isSupervisor)))"
                                           @click="saveData" large color="primary">Guardar
                                    </v-btn>

                                </div>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
      <v-dialog
          v-model="dialogApprove"
          max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span>Se ha enviado para aprobación la actividad</span>
          </v-card-title>
          <v-card-actions>
            <v-btn
                color="primary"
                text
                @click="dialogApprove = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogCommentApprove"
          max-width="700px"
          transition="dialog-bottom-transition"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialogCommentApprove = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Comentario de aprobación</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="formApprove" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-textarea
                      label="Comentario"
                      v-model="comment"
                      :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 2000) || 'El número de caracteres debe ser menor a 2000']"
                      required
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn @click="dialogCommentApprove = false" large color="primary">Cerrar</v-btn>
                <v-btn @click="commentActivity('APROBADO')" large color="primary">APROBAR ACTIVIDAD</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogCommentReject"
          max-width="700px"
          transition="dialog-bottom-transition"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialogCommentApprove = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Comentario de rechazo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="formReject" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-textarea
                      label="Comentario"
                      v-model="comment"
                      :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 2000) || 'El número de caracteres debe ser menor a 2000']"
                      required
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn @click="dialogCommentReject = false" large color="primary">Cerrar</v-btn>
                <v-btn @click="commentActivity('RECHAZADO')" large color="primary">RECHAZAR ACTIVIDAD</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogComment"
          max-width="700px"
          transition="dialog-bottom-transition"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialogComment = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Comentario</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="formComment" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-textarea
                      label="Comentario"
                      v-model="comment"
                      :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 2000) || 'El número de caracteres debe ser menor a 2000']"
                      required
                  ></v-textarea>
                </v-flex>
              </v-layout>
                  <div class="text-xs-center">
                    <v-btn @click="dialogComment = false" large color="primary">Cerrar</v-btn>
                    <v-btn @click="commentActivity('')" large color="primary">Comentar</v-btn>
                  </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogComments"
          fullscreen
          transition="dialog-bottom-transition"
          scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialogComments = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Comentarios</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="formComment" v-model="valid" lazy-validation>
              <v-data-table v-if="activity!=null && activity.comments!=''"
                  :headers="headersComments"
                  :items="activity.comments"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  hide-actions
                  hide-details
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ getFormattedDate(props.item.date) }}</td>
                  <td class="text-xs-left">{{ props.item.user.identification}} - {{ props.item.user.firstName}} {{ props.item.user.lastName}} </td>
                  <td class="text-xs-left">{{ props.item.comment }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  No se han encontrado resultados para "{{ search }}".
                </v-alert>
              </v-data-table>
              <div class="text-xs-center">
                <v-btn @click="dialogComments = false" large color="primary">Cerrar</v-btn>
                <v-btn @click="dialogComment = true" large color="primary">Nuevo Comentario</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>

import Activity from "../../model/Activity";

export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogApprove: false,
                dialogCommentApprove: false,
                dialogCommentReject: false,
                dialogComment: false,
                dialogComments: false,
                fechaInicio: '',
                fechaFin: '',
                menu: false,
                menu2: false,
                headers: [
                      {text: 'Código', value: 'id'},
                      {text: 'Fecha', value: 'date'},
                      {text: 'Compañia', value: 'activityConfigurationCompany.company.name'},
                      {text: 'Actividad', value: 'activityConfigurationCompany.name'},
                      {text: 'Nombre / Objetivo', value: 'name'},
                      {text: 'Descripción', value: 'description'},
                      {text: 'Período', value: 'activityCompanyPeriod.name'},
                      {text: 'Estado', value: 'status'},
                      {text: 'Anexos', value: 'anexos'},
                      {text: 'Ver actividad', value: ''},
                      {text: 'Ejecución', value: ''},
                      {text: 'Comentarios', value: ''},

                  ],
                  headersAnexo: [
                      {text: 'Nombre', value: 'name'},

                  ],
                headersComments: [
                  {text: 'Fecha', value: 'date'},
                  {text: 'Usuario', value: 'user'},
                  {text: 'Comentario', value: 'comment'},
                ],
                  items: ['TIPO_DOCUMENTO'],
                  editedIndex: -1,
                  activity: null,
                  anexo: {},
                  activities:[],
                  comment:"",
                  activitiesConfig:[],
                  isMedico: false,
                  isSupervisor: false,
                  isMedicoCliente: false,
                  estados:['CREADO','PENDIENTE_APROBACION','APROBADO','RECHAZADO','INCUMPLIDO','TODOS'],
                  estado:'',
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.activity = null;
                this.valid = false;
                this.dialog = false;
            },
            newCatalog() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
            },

          saveData() {
            if (this.$refs.form.validate()) {
              this.activity.questions = JSON.stringify(this.activity.questions)
              this.activity.comments = this.activity.comments!=''?JSON.stringify(this.activity.comments):""
              this.activity.activityConfigurationCompany = {id:this.activity.activityConfigurationCompany.id}
              this.$store.dispatch('updateActivity', this.activity).then(
                  response => {
                    this.reloadData();
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
              );

            }
          },
          getAnexos(item) {
            this.activity = Object.assign({}, item)
            this.$store.state.activity = this.activity
            this.$router.push({name: 'activityFile'});
          },
            editItem(item) {
              this.activity = Object.assign({}, item);
              this.dialog = true
            },
          selectItem(item) {
            this.activity = Object.assign({}, item);

          },
          commentActivity(item) {
            if(item=='APROBADO'){
              this.activity.status = item
            }else if(item=='RECHAZADO'){
              if(this.activity.timesRejected==1){
                this.activity.status = 'INCUMPLIDO'
              }else{
                this.activity.status = item
              }
              this.activity.timesRejected = this.activity.timesRejected + 1
            }
            if (this.activity.comments == "") {
              this.activity.comments = []
            }
              this.activity.comments.push({comment:this.comment, date:new Date(), user:{id:this.$store.state.userInSession.id, identification:this.$store.state.userInSession.identification, firstName:this.$store.state.userInSession.firstName, lastName:this.$store.state.userInSession.lastName}})
              this.activity.comments = this.activity.comments!=''?JSON.stringify(this.activity.comments):""
              this.activity.questions = JSON.stringify(this.activity.questions)
              this.activity.activityConfigurationCompany = {id:this.activity.activityConfigurationCompany.id}
              this.$store.dispatch('updateActivity', this.activity).then(
                  response => {
                    this.reloadData();

                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
              );
              this.dialogSuccess = true;

          },
            createApprove(item) {
              this.activity = Object.assign({}, item);
              this.activity.status = "PENDIENTE_APROBACION"
              //this.activity.comments = []
              this.activity.comments.push({comment:'Se ha enviado para aprobación la actividad.', date:new Date(), user:{id:this.$store.state.userInSession.id, identification:this.$store.state.userInSession.identification, firstName:this.$store.state.userInSession.firstName, lastName:this.$store.state.userInSession.lastName}})
              this.activity.comments = this.activity.comments!=''?JSON.stringify(this.activity.comments): ''
              this.activity.questions = JSON.stringify(this.activity.questions)
              this.activity.activityConfigurationCompany = {id:this.activity.activityConfigurationCompany.id}
              this.$store.dispatch('updateActivity', this.activity).then(
                  response => {
                    this.dialogApprove = true;
                    this.reloadData();
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
              );
            },

            deleteItem(item) {
                this.editedIndex = this.$store.state.catalogs.indexOf(item);
                this.catalog = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteCatalog', this.catalog.id);
            },
            getCatalogParentIdName(id) {
                for (var i = 0; i < this.$store.state.catalogs.length; i++) {
                    if (this.$store.state.catalogs[i].id === id) {
                        return id + ' - ' + this.$store.state.catalogs[i].name;
                    }
                }
            },
            handleFileSelect(evt) {
                this.$store.state.fileData.push(evt.target.files[0])
                this.anexo.fileName = evt.target.files[0].name
                this.anexo.fileType = evt.target.files[0].type
                this.anexo.file = window.btoa("binaryData");
                let f = evt.target.files[0]; // FileList object
                let reader = new FileReader();
                const self = this;
                // Closure to capture the file information.
                reader.onload = (function (f) {
                    return function (e) {
                        let binaryData = e.target.result;
                        //Converting Binary Data to base 64
                        let base64String = window.btoa(binaryData);
                        self.anexo.file = base64String
                        self.activity.anexos.push(self.anexo)
                        self.anexo = {}
                        evt.target.files = []
                    };
                })(f);
                // Read in the image file as a data URL.
                reader.readAsBinaryString(f);
            },
            download() {

            },
            deleteItemAnexo(item) {
                this.editedIndex = this.activity.anexos.indexOf(item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.activity.anexos.splice(this.editedIndex, 1)
            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
          getFormattedOnlyDate(dateReg) {
            var ua = navigator.userAgent.toLowerCase();
            var date;
            if (true) {
              // Para Safari
              if (!(dateReg instanceof Date)) {
                var b = dateReg.toString().split(/\D/);
                date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
              } else {
                date = new Date(dateReg);
              }
            } else {
              // Otros navegadores
              date = new Date(dateReg);
            }
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var hour = date.getHours();
            var min = date.getMinutes();
            var sec = date.getSeconds();
            month = (month < 10 ? "0" : "") + month;
            day = (day < 10 ? "0" : "") + day;
            hour = (hour < 10 ? "0" : "") + hour;
            min = (min < 10 ? "0" : "") + min;
            sec = (sec < 10 ? "0" : "") + sec;
            var str = date.getFullYear() + "-" + month + "-" + day;
            return str;
          },
            reloadData(){
              this.dialogCommentApprove = false
              this.dialogCommentReject = false
              this.dialogComment = false
              this.dialogComments = false
              this.dialogSuccess = true
              this.activity=null
              this.activities=[]
              this.comment=""
              let usersCompanyActivityByUser=[]
              this.$store.dispatch('getUsersCompanyActivityByUser',this.$store.state.userInSession.id).then(response => {
                usersCompanyActivityByUser = response.data
              })

              this.$store.state.searchObjectActivity = {company:null,fechaInicio:this.fechaInicio, fechaFin: this.fechaFin, estado:(this.estado=='TODOS' ||this.estado=='') ?null:this.estado, activityConfigurationCompany: null}
              this.$store.dispatch('findActivityDateStatus',this.$store.state.searchObjectActivity).then(response => {
                for (const act of response.data) {
                  this.isMedico= false
                  this.isSupervisor= false
                  this.isMedicoCliente= false
                  //Se transforma a json para trabajar
                  if (act.activityConfigurationCompany.months != null && act.activityConfigurationCompany.months != '') {
                    act.activityConfigurationCompany.months = JSON.parse(act.activityConfigurationCompany.months)
                  }
                  if (act.comments != null && act.comments != '') {
                    act.comments = JSON.parse(act.comments)
                  }
                  if(act.comments == null ){
                    act.comments = []
                  }
                  if(act.questions!=""){
                    act.questions = JSON.parse(act.questions)
                  }
                  if (act.activityConfigurationCompany.questions != null && act.activityConfigurationCompany.questions != '' && act.questions=="") {

                    let questions = JSON.parse(act.activityConfigurationCompany.questions)
                    act.questions=[]
                    let i=0
                    for (const questionData of questions) {
                      let newQuestion = {id: i,question:questionData, response:""}
                      act.questions.push(newQuestion)
                      i++;
                    }
                  }
                  if (act.activityConfigurationCompany.trimester != null && act.activityConfigurationCompany.trimester != '') {
                    act.activityConfigurationCompany.trimester = JSON.parse(act.activityConfigurationCompany.trimester)
                  }
                  act.activityConfigurationCompany.children = []
                  let insert = 0;
                  for (const data of usersCompanyActivityByUser) {

                    if(data.tipo == 's' && data.company.id == act.activityConfigurationCompany.company.id){
                      this.isSupervisor = true
                      act.isSupervisor = this.isSupervisor
                      if(insert==0){
                        this.activities.push(act)
                      }
                      insert = 1
                    }
                    if(data.tipo == 'u' && data.company.id == act.activityConfigurationCompany.company.id){
                      this.isMedico = true
                      act.isMedico = this.isMedico
                      if(insert==0){
                        this.activities.push(act)
                      }
                      insert = 1
                    }
                    if(data.tipo == 'c' && data.company.id == act.activityConfigurationCompany.company.id){
                      this.isMedicoCliente = true
                      act.isMedicoCliente = this.isMedicoCliente
                      if(insert==0){
                        this.activities.push(act)
                      }
                      insert = 1
                    }
                  }
                }
              }, error => {
                this.$store.state.dialogError = true
              })
            },
          getColor(item){
            if(item=="CREADO"){
              return "background-color: yellow"
            }else if(item=="PENDIENTE_APROBACION"){
              return "background-color: blue"
            }else if(item=="APROBADO"){
              return "background-color: green"
            }else if(item=="RECHAZADO"){
              return "background-color: red"
            }else if(item=="INCUMPLIDO"){
              return "background-color: brown"
            }
          },
        },
        computed: {},
        beforeCreate() {

        },
        created() {
          if(this.$store.state.searchObjectActivity==null){
            this.fechaFin = this.getFormattedOnlyDate(new Date())
            this.fechaInicio = new Date()
            this.fechaInicio.setMonth(this.fechaInicio.getMonth() - 2)
            this.fechaInicio = this.getFormattedOnlyDate(this.fechaInicio)
            this.estado = 'TODOS'
            this.reloadData();
          }else{
            this.fechaFin = this.$store.state.searchObjectActivity.fechaFin
            this.fechaInicio = this.$store.state.searchObjectActivity.fechaInicio
            this.estado = this.$store.state.searchObjectActivity.estado
            this.reloadData();
          }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activity/ActivityList.vue